<template>
    <div>
        <div class="example-list clearfix">
            <router-link 
                class="example-list-item" 
                v-for="k in exampleList" 
                :key="k.id" 
                :class="'example-list-item_' + k.class" 
                :to="k.link"
            >
                <div class="example-list-item-image">
                    <img :src="k.image">
                    <img class="front-img" :src="k.image">
                    <div class="example-list-item-image_line"></div>
                </div>
                <div class="example-list-item-date">
                    {{k.date}}
                </div>
                <p 
                    class="example-list-item-text" 
                    v-html="k.title"
                >
                
                </p>
            </router-link>
            <div class="example-list-item_end"></div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'TheExampleExampleList',
    props: {
        exampleList: Array
    },
}
</script>

<style scoped>


@media screen and (min-width: 801px) {
    .example-title {
        padding: 12px 0 50px;
    }

    .example-list {
        max-width: 1200px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .example-list-item_style1 {
        display: block;
        /*float: left;*/
        width: 30.5%;
        height: 485px;
        overflow: hidden;
    }

    .example-list-item_style2 {
        display: block;
        /*float: left;*/
        width: 65.25%;
        height: 485px;
        overflow: hidden;
    }

    .example-list-item-image {
        position: relative;
        min-height: 238px;
        overflow: hidden;
    }

    .front-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        transform-origin: center;
        transform: scale(1);
        transition: all .2s linear
    }

    .example-list-item-image_line {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 12px;
        background-color: #ff764e;
        transform: scale(0, 1);
        /*transition: all .2s linear;*/
    }

    .example-list-item_style1:hover .example-list-item-image_line,
    .example-list-item_style2:hover .example-list-item-image_line {
        transform: scale(1, 1);
    }
    .example-list-item_style1:hover .example-list-item-date,
    .example-list-item_style2:hover .example-list-item-date {
        color: #FF764E;
    }

    .example-list-item_style1:hover .front-img,
    .example-list-item_style2:hover .front-img {
        transform: scale(1.2);
    }


    .example-list-item_end {
        width: 100%;
        height: 1px;
    }

    .example-list-item-date {
        padding: 20px 0;
        font-size: 14px;
        color: #666;
    }
    .example-list-item-text {
        font-size: 38px;
    }
}


@media screen and (max-width: 800px) {
    .example-title {
        padding-bottom: .32rem;
    }

    .example-list {
        width: 9.04rem;
        margin: 0 auto;
    }

    .example-list-item {

    }

    .example-list-item-image {
        position: relative;
        overflow: hidden;
    }

    .front-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        transform-origin: center;
        transform: scale(1);
        transition: all .2s linear
    }

    .example-list-item-image_line {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: .32rem;
        background-color: #ff764e;
        transform: scale(0, 1);
        /*transition: all .2s linear;*/
    }

    .example-list-item:active .example-list-item-image_line{
        transform: scale(1, 1);
    }
    .example-list-item:active .example-list-item-date {
        color: #FF764E;
    }

    .example-list-item:active .front-img {
        transform: scale(1.2);
    }
    .example-list-item:hover .example-list-item-text {
        color: #333;
    }
    .example-list-item:active .example-list-item-text{
         color: #FF764E;
    }


    .example-list-item_end {
        width: 100%;
        height: 1px;
    }

    .example-list-item-date {
        padding: .26rem 0 .1rem;
        font-size: .37rem;
        color: #666;
    }
    .example-list-item-text {
        font-size: .4rem;
        padding-bottom: .52rem;
    }
}



</style>